import sliceCreator from '../../index.js';
import {CREATE_USER} from '../../../constants/index.js';
const _createUserAction = sliceCreator('CREATE_USER', CREATE_USER, 'post');

const { asyncAction: createUserAction, reducer, clearData: clearCreateUserAction } = _createUserAction;

export default reducer;

export {
    createUserAction,
    clearCreateUserAction
}